import i18n from "i18next";
import Backend from "i18next-xhr-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { reactI18nextModule, translate } from "react-i18next";

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(reactI18nextModule)
  .init({
    fallbackLng: "en",
    // have a common namespace used around the full app
    ns: ["translations"],
    defaultNS: "translations",
    debug: true,
    react: {
      wait: true,
    },
  });

translate.setI18n(i18n);

export const currentLanguage = () => i18n.language;
export const isUSD = () => currentLanguage() !== "ru";

export function currency(amount) {
  if (isUSD()) {
    return `$${(amount / 100).toFixed(2)}`;
  }
  return `${amount}\xa0₽`;
}

export function changeLocale() {
  const currencyCode = localStorage.getItem("currencyCode");
  localStorage.setItem("currency", currencyCode === 1 ? 0 : 1);
  window.location = "/";
}

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n.js